import { useAddToCollection, useDeleteCollection, useGetCollection } from "../../../api/query_hooks";
import TitleBarBackButton from "../../../components/layout/title_bar/TitleBarBackButton";
import TitleBarMenuItem from "../../../components/layout/title_bar/TitleBarMenuItem";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import TitleBarMenu from "../../../components/layout/title_bar/TitleBarMenu";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import { Button, Col, Form, Modal, Spinner } from "react-bootstrap";
import { getArtworkImageUrl } from "../../../api/endpoints";
import Panel from "../../../components/layout/panel/Panel";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Collection = ({code}) => {
    
    const collectionQuery = useGetCollection(code);
    const deleteMutation = useDeleteCollection();

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const navigate = useNavigate();


    const deleteCollection = () => {
        deleteMutation.mutate(code);
        navigate("/collections");
    }


    return(
        <>
        {collectionQuery.isLoading &&
            <div className="bg-black d-flex justify-content-center align-items-center container">
                <Spinner animation="border" role="status" aria-describedby="loading" />
            </div>
        }
        {collectionQuery.isError &&
            <Panel>
                {collectionQuery.error.response?.data}
            </Panel>
        }
        {collectionQuery.isSuccess &&
            <Panel>
                <Modal size="sm" show={showDeleteModal} centered onHide={() => setShowDeleteModal(false)} >
                    <Modal.Body className="d-flex flex-column gap-4 bg-dark p-4 rounded">
                        <span>Do you really want to delete this collection?</span>
                        <div className="d-flex justify-content-between">
                            <Button className="border-secondary" variant="dark" onClick={() => setShowDeleteModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="warning" type="button" onClick={deleteCollection}>
                                Confirm
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <TitleBar className="bg-dark my-2 rounded">
                    <TitleBarBackButton to="/collections" />
                    <TitleBarTitle>{collectionQuery.data?.data.title}</TitleBarTitle>
                    <TitleBarMenu>
                        <TitleBarMenuItem onClick={() => setShowDeleteModal(true)}>
                            <box-icon color='red' name='trash'></box-icon>
                            <span>Delete</span>
                        </TitleBarMenuItem>
                    </TitleBarMenu>
                </TitleBar>

                <div className="flex-grow- d-flex flex-wrap w-100 p-2 mb-2">
                    {(collectionQuery.isSuccess) &&
                    collectionQuery.data?.data.artworks.map((artwork, index) => {
                        return(
                            <Thumbnail
                                as="link"
                                to={'/artworks/'+artwork.code}
                                src={!!artwork.images.length ? getArtworkImageUrl(artwork.images[0].path) : process.env.PUBLIC_URL+"/default_artwork.png"}
                                className="p-1 w-33 w-lg-25 border-black border-2 rounded-3 overflow-hidden"
                            />
                        )
                    })}
                </div>

                <div className="flex-grow-1 invisible border"></div>

                <Col className="bg-dark flex-grow-0 d-flex flex-column w-100 p-3 rounded">
                    {(!!collectionQuery.data?.data.description) &&
                    <p><span className="text-white-50 me-2">Description:</span>{collectionQuery.data?.data.description}</p>}
                    {(!!collectionQuery.data?.data.tags?.length) &&
                    <p className="m-0"><span className="text-white-50 me-2">Tags:</span>
                        {collectionQuery.data?.data.tags?.map((tag, index) => {
                            return <span key={index}>#{tag.tag} </span>
                        })}
                    </p>}
                </Col>
            </Panel>
        }
        <AddToCollectionButton />
        </>
    )
}


const AddToCollectionButton = () => {
    const [show, setShow] = useState(false);

    const submitButtonRef = useRef();
    
    const mutation = useAddToCollection();

    const createCollection = (e) => {
        e.preventDefault();

        mutation?.mutate({});

        setShow(false);
    };

    useEffect(() => {
        if(mutation?.isSuccess && !mutation?.isError) {
            setShow(false);
        }
    }, [mutation?.isSuccess, mutation?.isError]);


    return (
        <>
            <Modal size="lg" show={show} fullscreen="md-down" centered onHide={() => setShow(false)}>
                <Modal.Header className="bg-dark rounded-md-top" closeButton>
                    <Modal.Title>Add artwork to Collection</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark">
                    <Form encType="multipart/form-data" onSubmit={createCollection} >

                        <Button type="submit" className="hidden" ref={submitButtonRef} />
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-dark justify-content-between gap-2 rounded-md-bottom">
                    <Button variant="dark" className="border-secondary" onClick={() => setShow(false)} >
                        <span>Cancel</span>
                    </Button>
                    <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => submitButtonRef.current.click()} aria-describedby="save" disabled={mutation?.isFetching}>
                        {mutation?.isFetching && <Spinner size="sm" animation="border" role="status" />}
                        {!mutation?.isFetching && <span className="text-dark">Save</span>}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Button variant="link" className="position-absolute bottom-0 end-0 d-flex p-0 m-5" onClick={() => setShow(true)} aria-describedby="new collection" >
                <box-icon name='plus-circle' size='lg' type='solid' color='#ffc107' ></box-icon>
            </Button>
        </>
    );
}


export default Collection;